module.exports = {
      id: "nav-icon-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "images/js_src_vue/page_eagle_landing/sprite.b4f41d19.svg#nav-icon-usage",
      toString: function () {
        return this.url;
      }
    }